import React from 'react';
import { Book, Quote, Scale, Brain, Heart } from "lucide-react";
import { TextSection } from './TextSection';
import { ScriptureReferences } from './ScriptureReferences';
import { Objections } from './Objections';
import { SectionProps } from './types';

export const ResponseContent: React.FC<SectionProps> = ({ item }) => {
  const { response } = item.content;
  
  if (!response) {
    return (
      <div className="text-center py-6">
        <p className="text-gray-500">No response data available.</p>
      </div>
    );
  }

  // Keep only sections that have meaningful content
  const sections = [
    {
      title: "Direct Answer",
      content: response.directAnswer,
      icon: <Quote className="h-5 w-5" />
    },
    {
      title: "Biblical Foundation",
      content: response.biblicalFoundation,
      icon: <Book className="h-5 w-5" />
    },
    {
      title: "Comparison of Beliefs",
      content: response.comparisonOfBeliefs,
      icon: <Scale className="h-5 w-5" />
    },
    {
      title: "Refutation from Their Texts",
      content: response.refutationFromTheirTexts,
      icon: <Book className="h-5 w-5" />
    },
    {
      title: "Logical & Theological Reasoning",
      content: response.theologicalReasoning,
      icon: <Brain className="h-5 w-5" />
    }
  ].filter(section => section.content?.trim());

  return (
    <div className="space-y-6">
      <h3 className="text-xl font-medium text-heaven-gold mb-4 text-left">Response:</h3>
      
      {/* Display the sections */}
      {sections.map((section, index) => (
        <TextSection
          key={index}
          title={section.title}
          content={section.content}
          icon={section.icon}
        />
      ))}
      
      {/* Scripture References */}
      {response.scriptureReferences && 
       Array.isArray(response.scriptureReferences) && 
       response.scriptureReferences.length > 0 && (
        <ScriptureReferences references={response.scriptureReferences} />
      )}
      
      {/* Objections */}
      {response.commonObjections && 
       Array.isArray(response.commonObjections) && 
       response.commonObjections.length > 0 && (
        <Objections 
          objections={response.commonObjections} 
          faithGroup={item.content.faithGroup} 
        />
      )}

      {/* Final Appeal - special styling */}
      {response.finalAppeal && (
        <TextSection
          title="Final Gospel Appeal"
          content={response.finalAppeal}
          icon={<Heart className="h-5 w-5" />}
          className="bg-heaven-gold/5"
        />
      )}
    </div>
  );
};
